import React from 'react';

export interface IConfigControlProps {
  config: string;
  elementFor: string | Array<string>;
  children: any;
}

export default function ConfigControl(props: IConfigControlProps) {
  const { config, elementFor, children } = props;
  if (Array.isArray(elementFor)) {
    const child = elementFor.find((ele) => ele === config) ? children : null;
    return <React.Fragment> {child}</React.Fragment>;
  } else {
    const child = config === elementFor ? children : null;
    return <React.Fragment> {child}</React.Fragment>;
  }
}
